export default __webpack_public_path__ + "static/media/ineos_login.d18ef3a8.png";